// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1c7c7475","337":"ff119c73","453":"31bf9d75","455":"cb08d11e"}[chunkId] + ".chunk.js";
};